/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_f1_myteam_signin_cta = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign in`)
};

const es_f1_myteam_signin_cta = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iniciar sesión`)
};

const de_f1_myteam_signin_cta = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anmelden`)
};

const nl_f1_myteam_signin_cta = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aanmelden`)
};

const fr_f1_myteam_signin_cta = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se connecter`)
};

const it_f1_myteam_signin_cta = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accedi`)
};

const pt_br2_f1_myteam_signin_cta = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrar`)
};

const pt_f1_myteam_signin_cta = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iniciar sessão`)
};

const ja_f1_myteam_signin_cta = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`サインイン`)
};

const zh_f1_myteam_signin_cta = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`登录`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const f1_myteam_signin_cta = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.f1_myteam_signin_cta(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("f1_myteam_signin_cta", locale)
	if (locale === "en") return en_f1_myteam_signin_cta(inputs)
	if (locale === "es") return es_f1_myteam_signin_cta(inputs)
	if (locale === "de") return de_f1_myteam_signin_cta(inputs)
	if (locale === "nl") return nl_f1_myteam_signin_cta(inputs)
	if (locale === "fr") return fr_f1_myteam_signin_cta(inputs)
	if (locale === "it") return it_f1_myteam_signin_cta(inputs)
	if (locale === "pt-BR") return pt_br2_f1_myteam_signin_cta(inputs)
	if (locale === "pt") return pt_f1_myteam_signin_cta(inputs)
	if (locale === "ja") return ja_f1_myteam_signin_cta(inputs)
	return zh_f1_myteam_signin_cta(inputs)
};